import {TweenLite} from 'gsap';
import {formatNumber} from '../helpers';

export default class CounterComponent {
  static #intersectionObserver = null;

  static init($counter) {
    if (!$counter || $counter.counterComponent) {
      return;
    }

    $counter.counterComponent = new CounterComponent($counter);
  }

  static initAll() {
    document.querySelectorAll('[data-counter]').forEach(($counter) => {
      CounterComponent.init($counter);
    });
  }

  constructor($counter) {
    let options = JSON.parse($counter.dataset.counter || '{}') || {};

    let defaults = {
      from: 0,
      to: parseFloat($counter.innerText.replace(/\s+/g, '')),
      duration: 1,
      delay: 0,
      thousandsSeparator: '',
      commaSeparator: '.',
      fractionDigits: 0,
      startWhenInViewport: true,
      once: false
    };

    this.$counter = $counter;
    this.options = {...defaults, ...options};
    this.number = this.options.from;
    this.isStarted = false;

    this.init();
  }

  init() {
    this.updateText();

    if (!CounterComponent.#intersectionObserver) {
      CounterComponent.#intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          let counter = entry.target.counterComponent;

          if (entry.isIntersecting) {
            counter.countUp();
          } else {
            counter.countDown();
          }
        });
      });
    }

    if (this.options.startWhenInViewport) {
      CounterComponent.#intersectionObserver.observe(this.$counter);
    }
  }

  destroy() {
    if (this.options.startWhenInViewport) {
      CounterComponent.#intersectionObserver.unobserve(this.$counter);
    }

    TweenLite.killTweensOf(this);
    this.$counter.counterComponent = null;
  }

  updateText() {
    this.$counter.innerText = formatNumber(this.number, {
      thousandsSeparator: this.options.thousandsSeparator,
      commaSeparator: this.options.commaSeparator,
      fractionDigits: this.options.fractionDigits
    });
  }

  countUp() {
    if (this.options.once && this.isStarted) {
      return;
    }

    this.isStarted = true;

    TweenLite.killTweensOf(this);

    TweenLite.to(this, this.options.duration, {
      number: this.options.to,
      delay: this.options.delay,
      onUpdate: () => {
        this.updateText();
      }
    });
  }

  countDown() {
    if (this.options.once && this.isStarted) {
      return;
    }

    TweenLite.killTweensOf(this);

    TweenLite.to(this, this.options.duration, {
      number: this.options.from,
      delay: this.options.delay,
      onUpdate: () => {
        this.updateText();
      }
    });
  }
}
